import request from '@/utils/request'

// 查询维修分类关联租户列表分页
export function fetchList(query) {
    return request({
        url: '/upkeep/search/hot/keywords/page',
        method: 'get',
        params: query,
    })
}
// 查询维修分类关联租户详细
export function getObj(id) {
    return request({
        url: '/upkeep/search/hot/keywords/detail?id=' + id,
        method: 'get',
    })
}
// 新增维修分类关联租户
export function addObj(data) {
    return request({
        url: '/upkeep/search/hot/keywords/add',
        method: 'post',
        data: data,
    })
}
// 修改维修分类关联租户
export function putObj(data) {
    return request({
        url: '/upkeep/search/hot/keywords/edit',
        method: 'post',
        data: data,
    })
}
// 删除维修分类关联租户
export function delObj(data) {
    return request({
        url: '/upkeep/search/hot/keywords/delete',
        method: 'post',
        data: data,
    })
}
